export class Entry {
    collection: Entry[];
    callback: (url: string | undefined) => void;
    constructor(
        collection: Entry[],
        callback: (url: string | undefined) => void
    ) {
        this.collection = collection;
        this.callback = callback;
    }

    remove() {
        const index = this.collection.indexOf(this);
        if (index >= 0) this.collection.splice(index, 1);
    }
}
export class ReturnUrlObserver {
    listeners: Entry[] = [];
    constructor() {}

    registerReturnUrlEvent(callback: (url: string | undefined) => void) {
        const entry = new Entry(this.listeners, callback);
        this.listeners.push(entry);
        return entry;
    }

    changeReturnUrl(returnUrl: string | undefined | null) {
        if (returnUrl === null) returnUrl = undefined;
        this.invokeEvents(returnUrl);
    }

    invokeEvents(returnUrl: string | undefined) {
        for (const entry of this.listeners) {
            try {
                entry.callback(returnUrl);
            } catch (e) {
                console.error(e);
            }
        }
    }
}
export const observer = new ReturnUrlObserver();
